
import { useNavigate } from 'react-router-dom';
import '../cta/CTA.css'
import React from 'react';

export default function CTA({ id }) {

    const navigate = useNavigate()


    const handleMouseEnter = () => {
        document.querySelectorAll(`#${id} .box`).forEach((box) => box.classList.add('hovered'));
        document.querySelectorAll(`#${id} .box1`).forEach((box) => box.classList.add('hovered'));
        document.querySelectorAll(`#${id} .box2`).forEach((box) => box.classList.add('hovered'));
    };

    const handleMouseLeave = () => {
        document.querySelectorAll(`#${id} .box`).forEach((box) => box.classList.remove('hovered'));
        document.querySelectorAll(`#${id} .box1`).forEach((box) => box.classList.remove('hovered'));
        document.querySelectorAll(`#${id} .box2`).forEach((box) => box.classList.remove('hovered'));
    };




    return (
        <div className="flex flex-col justify-center items-center w-full pb-20 ">
            <div className='w-[90%] md:w-[80%] xl:w-3/5 flex flex-col justify-center items-center rounded-3xl bg-tealGreen h-72 font-sans  relative magic' onMouseEnter={() => handleMouseEnter()}
                onMouseLeave={() => handleMouseLeave()}>
                <div className='box rounded-3xl' id={id}></div>
                <div className='box1 rounded-3xl' id={id}></div>
                <div className='box2 rounded-3xl' id={id}></div>
                <p className='z-40 text-white leading-10 mx-4 text-center mb-8 font-pop font-medium text-2xl md:text-4xl magic'>Forward to the future with Paycott</p>
                <button
                    className='z-40 shadow-md font-medium text-lg border-gray-200 border-2 hover:bg-gray-300 h-12 w-2/3 bg-white rounded-full magic'
                    onClick={() => {
                        navigate('/signup')
                    }}
                >
                    Get Started
                </button>
            </div>

        </div>
    )
}

